module.exports = __webpack_public_path__ + "img/eg3.4c498d06.png";